export default __webpack_public_path__ + "static/media/vip_false.6103d02f.svg";